<template>
    <main id="home-wrapper">
        <div>
            <breadcrumb :breadcrumb="[
                { title: 'Community', url: '/', status: false },
                { title: 'Update Phone Number', url: app_url + '/event', status: true },
            ]"></breadcrumb>
            <section id="headline-events" class="section withPad blackBg">
                <div class="container">
                    <div class="wrapper-popup">
                        <div class="card-popup">
                            <div class="card-body">
                                <form @submit.prevent="onSubmitPhone" v-if="showFormPhone">
                                    <h4>Input Phone Number</h4>
                                    <div class="form-group row">
                                        <div class="col">
                                            <label class="label-form" for="hp">No Telepon</label>
                                            <div class="phonebox">
                                                <span class="input62">+62</span>
                                                <input type="number" class="form-control form-register" id="hp"
                                                    v-model="form.phone" aria-describedby="hp"
                                                    placeholder="8XXXXXXXX" />
                                            </div>
                                            <span class="help-block" v-if="form.errors.has('phone')"
                                                v-text="form.errors.get('phone')">
                                            </span>
                                            <span class="warning-text">Pastikan
                                                nomor Handphone yang digunakan sudah
                                                benar, jika sudah silahkan klik Selanjutnya</span>

                                        </div>
                                    </div>
                                    <div class="button">
                                        <div v-if="loaderPhone" class="loading loading-double"></div>
                                        <button v-else type="submit" class="btn btn-red mr-auto">Selanjutnya</button>
                                    </div>
                                </form>
                                <form @submit.prevent="onSubmitOtp" class="form-regis" v-else>
                                    <h4>Masukkan Kode Verifikasi</h4>
                                    <div>
                                        <p>OTP akan dikirimkan ke</p>
                                        <h5>(+62) {{ numberPhone }}</h5>
                                    </div>
                                    <div class="form-group verification-code">
                                        <input v-for="index in lengthCode" :name="`code-${index}`" maxlength="1"
                                            :key="index" :id="`code-${index}`" @input="inputHandler($event, index)"
                                            @keydown="backspaceHandler($event, index)" v-model="otpInput[index - 1]"
                                            type="text" />
                                    </div>
                                    <span class="help-block" v-if="form_otp.errors.has('otp')"
                                        v-text="form_otp.errors.get('otp')"></span>
                                    <div class="button">
                                        <div v-if="loaderOtp" class="loading loading-double"></div>
                                        <button v-else type="submit" class="btn btn-red mr-auto">Selanjutnya</button>
                                    </div>
                                    <div class="sendback" v-if="!loaderOtp">
                                        <small v-if="countDown > 0"> Kirim Ulang OTP Dalam {{ countDown }}
                                            Detik</small>
                                        <button @click="backInputNumber" type="button" class="btn btn-black"
                                            :disabled="countDown != 0">
                                            Kirim Ulang OTP
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </main>
</template>
<script>
import BreadCrumb from "../../widget/BreadCrumb";
export default {
    components: {
        breadcrumb: BreadCrumb,
    },
    data() {
        return {
            otpInput: Array(this.lengthCode).fill(''),
            lengthCode: 6,
            countDown: 60,
            showFormPhone: true,
            cdn_url: cdn_url,
            loaderPhone: false,
            loaderOtp: false,
            base_url: "",
            app_url: "",
            api_url: "",
            phone_number: null,
            form: new Form({
                _token: token,
                phone: ''
            }),
            form_otp: new Form({
                _token: token,
                phone: '',
                otp: ''
            })
        }
    },
    computed: {
        numberPhone: {
            get: function () {
                return this.phone_number;
            },
            // setter
            set: function (newValue) {
                return newValue.slice(2, newValue.length, -1)
            }
        }
    },
    created() {
        const checkInputPhone = localStorage.getItem('phone-send');
        const checkOtpCode = localStorage.getItem('otp-code');
        const event_hbd = localStorage.getItem('event-hbd');
        if (event_hbd) {
            this.event = JSON.parse(event_hbd);
        }
        if (checkInputPhone) {
            this.phone_number = parseInt(checkInputPhone);
            this.form_otp.phone = parseInt(checkInputPhone);
            this.showFormPhone = false;
            this.countDownTimer();
        }
    },
    methods: {
        trackerSubmit(event, isOtp) {
            let data = {
                'event': 'updateInformation',
                'eventDetail.category': 'Update Information HCID',
                'eventDetail.action': isOtp ? 'Masukan Kode Verifikasi - Selanjutnya' : 'Input Phone Number - Selanjutnya',
                'eventName': event.name, //Event Name
                'id': event.id, //Event ID
                'eventType': event.type,//Event Type
                'startDate': event.start_date, //Event Start Date
                'endDate': event.end_date, //Event End Date
                'publishedDate': event.created_at,//Event Created Date
                'province': event.province,//Event Province
            }
            console.log(data);
            dataLayer.push(data);
        },
        async onSubmitPhone() {
            this.loaderPhone = true;
            this.trackerSubmit(this.event, false);
            await this.form.post(`${api_url}/member/sent-otp`)
                .then((response) => {
                    if (response.status) {
                        localStorage.setItem('phone-send', response.phone);
                        this.showFormPhone = !this.showFormPhone;
                        this.phone_number = response.phone;
                        this.loaderPhone = false;
                        this.countDownTimer()
                    } else {
                        this.loaderPhone = false;
                    }
                }).catch((error) => {
                    this.loaderPhone = false;
                })
        },
        async onSubmitOtp() {
            this.loaderOtp = true;
            this.trackerSubmit(this.event, true);
            if (this.otpInput.length > 0) {
                const otp = this.otpInput.join('');
                this.form_otp.otp = parseInt(otp);
                this.form_otp.phone = this.phone_number;
            }
            await this.form_otp.post(`${api_url}/member/phone-update`)
                .then((response) => {
                    this.loaderOtp = false;
                    if (response.status) {
                        localStorage.setItem('otp-code', true);
                        window.location.href = `${this.event.detail_url_web}/verification-police-number`
                    }
                }).catch(error => {
                    this.loaderOtp = false;
                    console.log(error, 'error');
                })
        },
        backInputNumber() {
            this.showFormPhone = !this.showFormPhone;
            this.form = new Form({
                phone: ''
            })
            localStorage.removeItem('phone-send');
        },
        inputHandler(event, index) {
            const value = event.target.value;
            if (/^[0-9]$/.test(value)) {
                this.otpInput[index - 1] = value;
                if (index < this.lengthCode) {
                    this.$nextTick(() => {
                        this.goto(index + 1);
                    });
                }
            } else {
                this.otpInput[index - 1] = '';
            }
        },
        backspaceHandler(event, index) {
            if (event.key === 'Backspace' && index > 1 && !this.otpInput[index - 1]) {
                this.$nextTick(() => {
                    this.goto(index - 1);
                });
            }
        },
        goto(n) {
            if (n < 1) n = 1;
            if (n > this.lengthCode) n = this.lengthCode;

            const el = document.getElementById(`code-${n}`);
            if (el) el.focus();
        },
        countDownTimer() {
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            }
        },
    },
}
</script>
<style scoped lang="scss">
.wrapper-popup {
    position: relative;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .card-popup {
        position: relative;
        background-color: #fff;
        border-radius: 10px;
        padding: 10px;
        width: 558px;

        .button-close {
            position: absolute;
            left: auto;
            right: 15px;
        }

        .card-body {
            color: rgba(40, 40, 40, 1);
            height: 100%;

            p {
                font-size: 15px;
                width: 400px;
                color: rgba(63, 63, 63, 1);
            }

            .warning-text {
                margin-top: 5px;
            }

            .button {
                padding-top: 15px;

                .btn {
                    width: 100%;
                    max-width: 100%;
                    font-weight: 700;
                    font-size: 14px;
                    padding: 0;
                    height: 42px;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    &:hover {
                        background-color: #333 !important;
                        color: #fff;
                    }
                }
            }

            .form-regis {
                position: relative;

                .verification-code {
                    margin-top: 40px;
                    margin-bottom: 20px;
                    display: flex;
                    justify-content: space-between;
                    gap: 20px;

                    input {
                        font-size: 20px;
                        text-align: center;
                        width: 100%;
                        border: 2px solid rgba(180, 180, 180, 1);
                        border-top: none;
                        border-right: none;
                        border-left: none;

                        &::-webkit-outer-spin-button {
                            -webkit-appearance: none;
                            margin: 0;
                        }

                        &::-webkit-inner-spin-button {
                            -webkit-appearance: none;
                            margin: 0;
                        }
                    }
                }

                .sendback {
                    margin-right: auto;
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    padding-top: 20px;
                    text-align: center;
                    gap: 10px;
                    justify-content: center;
                    align-items: center;

                    .btn {
                        width: fit-content;
                        border-radius: 10px;
                        font-weight: 700;
                        font-size: 14px;
                        height: 42px;
                        cursor: pointer;

                        &:hover {
                            color: #fff;
                        }
                    }

                    small {
                        font-size: 14px;
                    }
                }
            }

            .phonebox {
                margin-bottom: 7px;
            }

            .red-button {
                width: 100%;
                background-color: #E61B33;
                color: #fff;
                padding: 10px 20px;
                border-radius: 10px;
                font-weight: 700;
                font-size: 14px;
                display: inline-block;
                cursor: pointer;
            }
        }
    }
}
</style>
